var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.16134 2.25576L14.18 5.5179C14.3574 5.63317 14.446 5.6908 14.5103 5.76768C14.5671 5.83574 14.6099 5.91445 14.6359 5.99922C14.6654 6.09498 14.6654 6.20073 14.6654 6.41224V11.3C14.6654 12.4201 14.6654 12.9802 14.4474 13.408C14.2556 13.7843 13.9497 14.0903 13.5733 14.2821C13.1455 14.5 12.5855 14.5 11.4654 14.5H4.53203C3.41193 14.5 2.85187 14.5 2.42405 14.2821C2.04773 14.0903 1.74176 13.7843 1.55002 13.408C1.33203 12.9802 1.33203 12.4201 1.33203 11.3V6.41224C1.33203 6.20073 1.33203 6.09498 1.36148 5.99922C1.38754 5.91445 1.43026 5.83574 1.48713 5.76768C1.55137 5.6908 1.64004 5.63317 1.81738 5.5179L6.83606 2.25576M9.16134 2.25576C8.74051 1.98222 8.5301 1.84545 8.30338 1.79224C8.10298 1.7452 7.89441 1.7452 7.69401 1.79224C7.4673 1.84545 7.25689 1.98222 6.83606 2.25576M9.16134 2.25576L13.2895 4.93904C13.748 5.2371 13.9773 5.38614 14.0567 5.57514C14.1261 5.7403 14.1261 5.92645 14.0567 6.09162C13.9773 6.28061 13.748 6.42965 13.2895 6.72772L9.16134 9.41099C8.74052 9.68453 8.53009 9.8213 8.30338 9.87452C8.10298 9.92155 7.89441 9.92155 7.69401 9.87452C7.4673 9.8213 7.25689 9.68453 6.83606 9.41099L2.70794 6.72772C2.24937 6.42965 2.02009 6.28061 1.94068 6.09162C1.87128 5.92645 1.87128 5.7403 1.94068 5.57514C2.02009 5.38614 2.24937 5.2371 2.70794 4.93904L6.83606 2.25576M14.332 13.1667L9.90348 9.16671M6.09391 9.16671L1.66536 13.1667",
    stroke: "#4F5B6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail05);
export default __webpack_public_path__ + "static/media/mail-05.158dacd62eb3a1b39e979a1f8a8be725.svg";
export { ForwardRef as ReactComponent };